import { RefObject, useEffect, useLayoutEffect, useRef } from "react";

export function useOutsideClick(
  refs: RefObject<HTMLElement | null>[],
  onOutside: () => void,
  active: boolean,
) {
  const latest = useRef({ refs, onOutside });
  useLayoutEffect(() => {
    latest.current = { refs, onOutside };
  });

  useEffect(() => {
    if (!active) return;
    function handleMouseDown(event: MouseEvent) {
      const target = event.target as Node;
      const inside = latest.current.refs.some((ref) =>
        ref.current?.contains(target),
      );
      if (!inside) latest.current.onOutside();
    }
    document.addEventListener("mousedown", handleMouseDown);
    return () => document.removeEventListener("mousedown", handleMouseDown);
  }, [active]);
}
